function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { IntlProvider, injectIntl } from 'react-intl';
import getDisplayName from '../../getDisplayName';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
var DEFAULT_LANG = 'en';
export function AdditionalIntl(_ref) {
  var messages = _ref.messages,
    children = _ref.children,
    path = _ref.path,
    namespace = _ref.namespace,
    intl = _ref.intl;
  var _useState = useState(DEFAULT_LANG),
    _useState2 = _slicedToArray(_useState, 2),
    lang = _useState2[0],
    setLang = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    fileAvailable = _useState4[0],
    setFileAvailable = _useState4[1];
  var _useState5 = useState(_objectSpread({}, messages, intl.messages)),
    _useState6 = _slicedToArray(_useState5, 2),
    translations = _useState6[0],
    setTranslations = _useState6[1];
  useEffect(function () {
    if (path && lang !== intl.locale && fileAvailable) {
      import("../../".concat(path, ".").concat(intl.locale, ".json")).then(function (translations) {
        // successfully got the file
        setLang(intl.locale);
        setTranslations(_objectSpread({}, normalizeLocaleData(translations.default, namespace), intl.messages));
      }).catch(function () {
        var _console;
        // language file doesn't exist, using English fallbacks
        // since they are already in state
        // in the future could warn that your language is not supported
        setFileAvailable(false);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        (_console = console).log.apply(_console, ['error loading language'].concat(args));
      });
    }
  }, [fileAvailable, intl.locale, intl.messages, lang, namespace, path]);
  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: intl.locale,
    messages: translations,
    textComponent: React.Fragment
  }, children);
}
var InjectAdditionalIntl = injectIntl(AdditionalIntl);
function isMessageProps(messages) {
  return messages.hasOwnProperty('messages') && typeof messages.path === 'string' && typeof messages.namespace === 'string';
}
export function withAdditionalIntl(messages) {
  var msgs = isMessageProps(messages) ? messages.messages : messages;
  var path = '';
  var namespace = '';
  if (isMessageProps(messages)) {
    var _messages$path = messages.path;
    path = _messages$path === void 0 ? '' : _messages$path;
    var _messages$namespace = messages.namespace;
    namespace = _messages$namespace === void 0 ? '' : _messages$namespace;
  }
  return function (WrappedComponent) {
    var Wrapped = function Wrapped(props) {
      return /*#__PURE__*/React.createElement(InjectAdditionalIntl, {
        messages: msgs,
        path: path,
        namespace: namespace
      }, /*#__PURE__*/React.createElement(WrappedComponent, props));
    };
    Wrapped.displayName = "WithAdditionalIntl(".concat(getDisplayName(WrappedComponent), ")");
    return Wrapped;
  };
}
export default InjectAdditionalIntl;